import { END_POINT } from "../constants/EndPoints";

import { fetchMiddleware, setIndexes } from "./MiddlewareActions";
import {
  BURST_DEFAULT_ALERT_STATES,
  DAY_MS,
  pickNoiseGraphRowForSample,
  toEpochMs,
} from "../utils/burstAlerts";

const actionsTypes = {
  REQUEST_BURST_ALERTS: 'REQUEST_BURST_ALERTS',
  RECEIVE_BURST_ALERTS: 'RECEIVE_BURST_ALERTS',
  SELECT_BURST_ALERT: 'SELECT_BURST_ALERT',
  SELECT_BURST_ALERT_SAMPLE: 'SELECT_BURST_ALERT_SAMPLE',
  REQUEST_BURST_ALERT_SENSOR_DATA: 'REQUEST_BURST_ALERT_SENSOR_DATA',
  RECEIVE_BURST_ALERT_SENSOR_DATA: 'RECEIVE_BURST_ALERT_SENSOR_DATA',
  UPDATE_BURST_ALERT_STATUS: 'UPDATE_BURST_ALERT_STATUS',
  SET_BURST_ALERTS_FILTERS: 'SET_BURST_ALERTS_FILTERS',
  SET_BURST_ALERTS_DEF_FILTERS: 'SET_BURST_ALERTS_DEF_FILTERS',
  BURST_ALERTS_SET_SORT_PROPS: 'BURST_ALERTS_SET_SORT_PROPS',
  REQUEST_BURST_ALERTS_HISTORY: 'REQUEST_BURST_ALERTS_HISTORY',
  RECEIVE_BURST_ALERTS_HISTORY: 'RECEIVE_BURST_ALERTS_HISTORY',
  RECEIVE_BURST_NOISE_GRAPH: 'RECEIVE_BURST_NOISE_GRAPH',
};

export const initialState = {
  burstAlerts: [],
  alertsIndexMap: {},
  alertSensorData: [],
  selectedAlert: undefined,
  selectedAlertSample: undefined,
  noiseGraphData: [],
  // Default status filter: New, To Be Located and Monitoring only. Replaced by
  // the user's saved filters (or the option-name-resolved defaults) once the
  // option list is loaded — see fetchOptions in GlobalsActions.
  filters: [{ field: 'alert_state', value: [...BURST_DEFAULT_ALERT_STATES] }],
  sortBy: { field: 'id', dir: 'asc' },
  defFilters: { alert_state: [...BURST_DEFAULT_ALERT_STATES] },
  history: [],
};

export function setFilters(filters) {
  return { type: actionsTypes.SET_BURST_ALERTS_FILTERS, filters };
}

export function setDefFilters(filters) {
  return { type: actionsTypes.SET_BURST_ALERTS_DEF_FILTERS, filters };
}

const requestBurstAlerts = (projectID) => ({
  type: actionsTypes.REQUEST_BURST_ALERTS,
  project: projectID,
});
const receiveBurstAlerts = (projectID, payload) => ({
  type: actionsTypes.RECEIVE_BURST_ALERTS,
  project: projectID,
  payload,
});

const fetchAlertHistory = (sensorId) => {
  return (dispatch, getState) => {
    const state = getState();
    const projectId = state.leaksList.selectedProject;
    const url = `${END_POINT}/burst/history/${projectId}/${sensorId}`;
    dispatch(requestBurstAlertHistory());
    return fetchMiddleware(url, {}, getState).then((json) => {
      console.log('[burst] history GET', url, '->', json);
      if (json.status) {
        dispatch(receiveBurstAlertHistory(json.data));
      }
    });
  };
};

const requestBurstAlertHistory = () => {
  return { type: actionsTypes.REQUEST_BURST_ALERTS_HISTORY };
};

const receiveBurstAlertHistory = (history) => {
  return { type: actionsTypes.RECEIVE_BURST_ALERTS_HISTORY, payload: history };
};

const slice = {
  actions: {
    fetchBurstAlerts: (projectID) => (dispatch, getState) => {
      const state = getState();
      const filters = state.burst.filters;
      const url = `${END_POINT}/burst/${projectID}`;
      const filtersQuery =
        filters.length > 0 ? `?filters=${JSON.stringify(filters)}` : '';
      dispatch(requestBurstAlerts(projectID));
      return fetchMiddleware(url + filtersQuery, {}, getState).then((json) => {
        console.log('[burst] fetchBurstAlerts GET', url + filtersQuery, '->', json, 'rows:', json && json.data ? json.data.length : 0);
        if (!json.status) {
          return false;
        } else {
          const burstAlertStatesOptions =
            state.leaksList.optionList.options.AlertStateNoise;
          const burstAlerts = json.data;
          burstAlerts.forEach((burstAlert) => {
            // The burst GET now returns a real ID; use it as the row identity
            // (drives selection, the details panel, the index map and the PUT
            // update URL — same as valve alerts). sensor_id stays the key for
            // the samples/history endpoints. Fall back to sensor_id if a row
            // somehow lacks an ID so selection still works.
            const realId =
              burstAlert.ID != null ? burstAlert.ID : burstAlert.id;
            burstAlert.ID = realId != null ? realId : burstAlert.sensor_id;
            burstAlert.id = burstAlert.ID;
            if (burstAlertStatesOptions) {
              const alertState = burstAlertStatesOptions.find(
                (opt) => opt.value === burstAlert.alert_state
              );
              burstAlert.AlertStateName = alertState ? alertState.DisplayName : '--';
            }
          });
          const indexMap = setIndexes(burstAlerts, 'ID');
          const payload = { items: burstAlerts, indexMap };
          return dispatch(receiveBurstAlerts(projectID, payload));
        }
      });
    },

    sortBurstAlerts: (field, dir) => {
      return (dispatch, getState) => {
        const state = getState();
        const projectID = state.leaksList.selectedProject;
        const burstAlerts = state.burst.burstAlerts;
        const sortedItems = burstAlerts.sort((first, second) => {
          let sortResult = 0;
          if (first[field] > second[field]) {
            sortResult = dir === 'asc' ? 1 : -1;
          } else if (first[field] < second[field]) {
            sortResult = dir === 'asc' ? -1 : 1;
          }
          return sortResult;
        });
        const newIndexMap = setIndexes(sortedItems, 'ID');
        const payload = { items: sortedItems, indexMap: newIndexMap };
        debugger;
        dispatch(receiveBurstAlerts(projectID, payload));
        dispatch(slice.actions.setSortDetails(field, dir));
      };
    },

    setSortDetails: (field, dir) => {
      return {
        type: actionsTypes.BURST_ALERTS_SET_SORT_PROPS,
        payload: { field, dir },
      };
    },

    selectBurstAlert: (alert) => (dispatch, getState) => {
      const state = getState();
      const projectId = state.leaksList.selectedProject;
      dispatch({ type: actionsTypes.SELECT_BURST_ALERT, payload: alert });
      // Selecting a different burst (or deselecting) must close the sample
      // strip left open from the previous burst: clear the selected sample
      // and its noise graph together.
      dispatch(slice.actions.selectBurstAlertSample(undefined));
      if (!alert || !alert.sensor_id) {
        return undefined;
      }
      dispatch({ type: actionsTypes.REQUEST_BURST_ALERT_SENSOR_DATA });
      if (alert !== null) {
        dispatch(fetchAlertHistory(alert.sensor_id));
      }
      function formatDate(date) {
        return new Date(date).toISOString().slice(0, 19).replace('T', ' ');
      }
      const url = `${END_POINT}/burst/${projectId}/${
        alert.sensor_id
      }?startDate=${formatDate(alert.create_date)}&endDate=${
        alert.last_event_date
          ? formatDate(alert.last_event_date)
          : formatDate(new Date())
        }`;
      return fetchMiddleware(url, {}, getState).then((json) => {
        console.log('[burst] samples GET', url, '->', json, 'rows:', json && json.data ? json.data.length : 0);
        return dispatch({
          type: actionsTypes.RECEIVE_BURST_ALERT_SENSOR_DATA,
          payload: json.status ? json.data : [],
        });
      });
    },

    updateBurstAlert: (burstAlert) => (dispatch, getState) => {
      const state = getState();
      const projectId = state.leaksList.selectedProject;
      const burstAlertId = burstAlert.ID;
      const alertSensorId = state.burst.selectedAlert.sensor_id;
      const url = `${END_POINT}/burst/${projectId}/${burstAlertId}`;
      return fetchMiddleware(
        url,
        {
          method: 'PUT',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(burstAlert),
        },
        getState
      ).then((json) => {
        console.log('[burst] updateBurstAlert PUT', url, '->', json);
        if (json.status) {
          dispatch({
            type: actionsTypes.UPDATE_BURST_ALERT_STATUS,
            payload: burstAlert,
          });
          dispatch(slice.actions.fetchBurstAlerts(projectId)).then((data) => {
            if (data.payload && data.payload.indexMap) {
              const { items, indexMap } = data.payload;
              const bAlert = items[indexMap[burstAlert.ID]];
              if (bAlert) {
                dispatch(slice.actions.selectBurstAlert(bAlert));
              }
            }
          });
          dispatch(fetchAlertHistory(alertSensorId));
        }
      });
    },

    selectBurstAlertSample: (sample) => (dispatch, getState) => {
      dispatch({ type: actionsTypes.SELECT_BURST_ALERT_SAMPLE, payload: sample });
      // Reset the previous sample's graph so the strip never shows stale data.
      dispatch({ type: actionsTypes.RECEIVE_BURST_NOISE_GRAPH, payload: [] });
      if (!sample) {
        return undefined;
      }
      // The "Noise Intensity Distribution" graph is fetched per device + sample
      // timestamp from the same endpoint the sensors strip uses; the burst
      // sample row itself does not carry the raw readings.
      const state = getState();
      const deviceId = state.burst.selectedAlert?.device_id;
      const sampleMs = toEpochMs(sample.time_stamp);
      if (deviceId == null || !Number.isFinite(sampleMs)) {
        return undefined;
      }
      // The device reports the graph once a day, at night, and a graph stamped
      // T holds the readings of the 24h *before* T. A sample from the 29th is
      // therefore described by the graph received on the 30th, not by the one
      // stamped the 29th (which describes the 28th). Ask for the graph at the
      // sample time and one day later, then keep the row whose window actually
      // contains the sample.
      const fetchGraph = (timeStamp) => {
        const url = `${END_POINT}/g5sensors/noiseGraph/${deviceId}/${timeStamp}`;
        return fetchMiddleware(url, {}, getState)
          .then((json) => {
            console.log('[burst] noiseGraph GET', url, '->', json);
            return json && Array.isArray(json.data) ? json.data : [];
          })
          .catch((error) => {
            console.warn('[burst] noiseGraph GET failed', url, error);
            return [];
          });
      };
      return Promise.all([
        fetchGraph(sampleMs),
        fetchGraph(sampleMs + DAY_MS),
      ]).then(([sameDayRows, nextDayRows]) => {
        // Another sample was selected while these requests were in flight.
        if (getState().burst.selectedAlertSample !== sample) {
          return;
        }
        const row = pickNoiseGraphRowForSample(
          [...sameDayRows, ...nextDayRows],
          sampleMs
        );
        dispatch({
          type: actionsTypes.RECEIVE_BURST_NOISE_GRAPH,
          payload: row ? [row] : [],
        });
      });
    },
  },

  reducer: (state = initialState, action) => {
    switch (action.type) {
      case actionsTypes.REQUEST_BURST_ALERTS:
        return { ...state, burstAlerts: [] };

      case actionsTypes.RECEIVE_BURST_ALERTS:
        return {
          ...state,
          burstAlerts: action.payload.items,
          alertsIndexMap: action.payload.indexMap,
        };

      case actionsTypes.SELECT_BURST_ALERT:
        return { ...state, selectedAlert: action.payload };

      case actionsTypes.REQUEST_BURST_ALERT_SENSOR_DATA:
        return { ...state, alertSensorData: [] };

      case actionsTypes.RECEIVE_BURST_ALERT_SENSOR_DATA:
        return { ...state, alertSensorData: action.payload };

      case actionsTypes.SELECT_BURST_ALERT_SAMPLE:
        return { ...state, selectedAlertSample: action.payload };

      case actionsTypes.RECEIVE_BURST_NOISE_GRAPH:
        return { ...state, noiseGraphData: action.payload };

      case actionsTypes.UPDATE_BURST_ALERT_STATUS:
        return {
          ...state,
          burstAlerts: state.burstAlerts.map((a) =>
            a.ID === action.payload.ID ? { ...a, ...action.payload } : a
          ),
        };

      case actionsTypes.SET_BURST_ALERTS_FILTERS:
        return { ...state, filters: action.filters };

      case actionsTypes.SET_BURST_ALERTS_DEF_FILTERS:
        return { ...state, defFilters: action.filters };

      case actionsTypes.REQUEST_BURST_ALERTS_HISTORY:
        return { ...state, history: [] };

      case actionsTypes.RECEIVE_BURST_ALERTS_HISTORY:
        return { ...state, history: action.payload };

      case actionsTypes.BURST_ALERTS_SET_SORT_PROPS:
        return {
          ...state,
          sortBy: { field: action.payload.field, dir: action.payload.dir },
        };

      default:
        return state;
    }
  },
};

export default slice.actions;

export { slice };
